import html2Canvas from 'html2canvas';
import JsPDF from 'jspdf';
import {
    Loading as loading
} from 'element-ui';
/*
    第一个参数: element元素,element类型。
    第二个参数: 文件名称，默认为表单, string类型。
    第三个参数: 回调，默认空函数, function 类型.
    在文件下载完成后，回调之前，会默认把传进去的第一个元素的display设置为none;
*/
export default {
    install(Vue, options) {
        Vue.prototype.getPdf = function (element, title = "表单", cb = function () {}) {
            let loadingInstance = loading.service({
                fullScreen: true,
                text: "加载中"
            });
            html2Canvas(element, {
                allowTaint: true
            }).then(function (canvas) {
                let contentWidth = canvas.width
                let contentHeight = canvas.height
                let pageHeight = contentWidth / 592.28 * 841.89
                let leftHeight = contentHeight
                let position = 0
                let imgWidth = 595.28
                let imgHeight = 592.28 / contentWidth * contentHeight
                let pageData = canvas.toDataURL('image/jpeg', 1.0)
                let PDF = new JsPDF('', 'pt', 'a4')
                if (leftHeight < pageHeight) {
                    PDF.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight)
                } else {
                    while (leftHeight > 0) {
                        PDF.addImage(pageData, 'JPEG', 0, position, imgWidth, imgHeight)
                        leftHeight -= pageHeight
                        position -= 841.89
                        if (leftHeight > 0) {
                            PDF.addPage()
                        };
                    };
                };
                PDF.save(title + '.pdf');
                cb();
                loadingInstance.close();
            })
        }
    }
}



// WEBPACK FOOTER //
// ./src/toPDF.js